'use client';

import { Button, type ButtonProps } from '@/app/components/ui/button';
import { reportEvent } from '@/app/utils';
import { useRouter } from '@/i18n/routing';

interface ClientButtonProps extends ButtonProps {
  href: string;
  children: React.ReactNode;
  withReportEvent?: boolean;
}

export default function ClientButton({
  variant = 'primary',
  size = 'default',
  href,
  children,
  withReportEvent = false,
  ...props
}: ClientButtonProps) {
  const router = useRouter();

  const handleClick = () => {
    router.push(href);
    if (withReportEvent) {
      reportEvent('element_click', {
        element_name: 'Generate Now',
      });
    }
  };

  return (
    <Button variant={variant} size={size} onClick={handleClick} {...props}>
      {children}
    </Button>
  );
}
